
import {Component, Prop, Vue} from "vue-property-decorator";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {IBook} from "@/interfaces/book.interface";
  import {httpResource} from "@/resources/http.resource";

  @Component({})
  export default class AppCorpsFilter extends Vue {
    @Prop() value: any;
    @Prop() valueString: string;

    corps = [];

    get storeState(): IAppState { return this.$store.state; }
    get corpsBook(): IBook.CorpBookItem[] { return this.storeState.book.books[IBook.BookName.Corps]; }
    get corpOptions() { return this.corps.length ? this.corps : this.corpsBook; }

    created() {
      this.presetBookItem();
    }

    presetBookItem() {
      if (!!this.valueString) {
        let bookValue = this.corpsBook.find(item => item.id === +this.value);
        if (!Boolean(bookValue)) {
          this.$store.commit('book/addItemInBook', {
            bookName: IBook.BookName.Corps,
            item: {
              id: +this.value,
              name: this.valueString,
            },
          });
        }
      }
    }

    async getCorps(corp) {
      let asyncAction = async () => {
        const params = { tableName: IBook.TableName.Corps, searchText: corp } ;
        const {data: {result: {corps: responseCorps } }} = await httpResource.httpAction({ action: IBook.ACTION, params });
        this.corps = responseCorps;
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    onChange(value) {
      let bookValue = this.corpOptions.find(item => item.id === +value);
      this.$emit('onChange', bookValue);
    }
    onInput(value) {
      this.$emit('input', value);
    }
    onBlur(event) {
      this.$emit('onBlur', { event, list: this.corpOptions });
    }
    onClear() {
      this.$emit('onClear');
    }
  }
